import _styled from "@emotion/styled-base";
var _excluded = ["fullWidth", "borderless", "shortTopMargin"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable id-blacklist, no-restricted-imports */
import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { media, variables, insetBlock, clearfix } from '@domain-group/fe-brary';
import { jsx as ___EmotionJSX } from "@emotion/core";
var colour = variables.colour,
  global = variables.global;
var border = /*#__PURE__*/css("border-top:1px solid ", colour.neutral200, ";");
export var Inner = _styled("div", {
  target: "emvs9pg0"
})(clearfix, ";", insetBlock, ";padding:0 15px;", media('>=tablet'), "{padding:0 24px;}", media('>=desktop'), "{padding:0;}");
export var InnerLeft = _styled("div", {
  target: "emvs9pg1"
})(clearfix, ";display:block;width:100%;padding-top:16px;margin-bottom:11px;", media('>=tablet'), "{width:50%;float:left;}", media('>=desktop'), "{width:640px;padding-top:0;border:0;margin-bottom:0;}");
export var Section = _ref => {
  var fullWidth = _ref.fullWidth,
    borderless = _ref.borderless,
    shortTopMargin = _ref.shortTopMargin,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("div", _extends({
    "data-testid": "section"
  }, props, {
    css: /*#__PURE__*/css("position:relative;margin-top:", shortTopMargin ? '9px' : '21px', ";padding-top:21px;", borderless ? '' : border, ";", media('>=tablet'), "{width:100%;}", media('>=desktop'), "{width:", fullWidth ? global.tabletMaxWidth : '640px', ";margin-top:", shortTopMargin ? '12px' : '24px', ";padding-top:24px;}")
  }));
};
Section.propTypes = {
  fullWidth: PropTypes.bool,
  borderless: PropTypes.bool,
  shortTopMargin: PropTypes.bool
};
Section.defaultProps = {
  fullWidth: false,
  borderless: false,
  shortTopMargin: false
};
export var Bottom = _styled("div", {
  target: "emvs9pg2"
})({
  name: "18h4a17",
  styles: "display:block;width:100%;float:left;"
});
export var HeroImages = _styled("div", {
  target: "emvs9pg3"
})("display:block;width:100%;background:", colour.neutral100, ";height:216px;position:relative;", media('>=tablet'), "{height:320px;}", media('>=desktop'), "{max-height:476px;height:60vh;}");
export var InnerRight = _styled("div", {
  target: "emvs9pg4"
})(clearfix, ";display:block;padding-top:12px;width:45%;max-width:320px;float:right;", media('>=tablet'), "{padding-top:0;}");
export var Clear = _styled("div", {
  target: "emvs9pg5"
})("clear:both;", props => props.border && border, ";");